import { isEmpty } from 'lodash';
import React from 'react';

import { useCurrentUser, useProfileUpdate } from '@hooks';
import Switch from '@mui/material/Switch';

/**
 * Used for Switch settings in the Profile. Not reusable outside of the profile
 * at this time, but could be refactored to use a general Switch component.
 */

interface ProfileSwitchSettingProps {
  userId: number;
  value: boolean;
  sanitizedFieldName: string;
  description: string;
  hint: string;
  hasOppositeValue?: boolean;
  handleError?: () => void;
}

const ProfileSwitchSetting = ({
  userId,
  value,
  sanitizedFieldName,
  description,
  hint,
  hasOppositeValue, // because mentioning_disabled column in db asks if they want mentioning enabled
  handleError,
}: ProfileSwitchSettingProps) => {
  const { saveProfile, showSave } = useProfileUpdate(userId);
  const { currentUser } = useCurrentUser();

  const checkedValue = hasOppositeValue ? !value : value;

  return (
    <div className="ProfileSwitchSetting">
      <div className="section-detail-container">
        {showSave && <div className="save-label success">Saved</div>}
        <div className="section-description">{description}</div>
        <Switch
          id={sanitizedFieldName}
          checked={checkedValue}
          onChange={() => {
            // A full name is required before a user can enable their profile.
            // Note that we are checking when `value` is false because we want to allow users who have not provided a name the ability to disable their profile (This is sort of edge case but as of this commit there were 33 users without a name with their profile enabled)
            if (
              sanitizedFieldName === 'profile_enabled' &&
              (currentUser?.name === 'Guest' || isEmpty(currentUser?.name)) &&
              handleError &&
              !value
            ) {
              handleError();
            } else {
              saveProfile({ [sanitizedFieldName]: !value });
            }
          }}
        />
      </div>
      <div className="hint">{hint}</div>
    </div>
  );
};

export default ProfileSwitchSetting;
